<template>
    <div :id="name" :class="tabPanelClass" role="tabpanel" :aria-labelledby="ariaLabel">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            required: true
        },
        selected: {
            default: false
        }
    },
    data() {
        return {
            tabPanelClass: {
                "tab-pane": true,
                fade: true,
                show: this.selected,
                active: this.selected
            },
            "ariaLabel": this.name + '-tab'
        };
    },
    computed: {}
}
</script>
